import { useMutation } from '@apollo/client';
import { Arrange } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  TAG_FOLLOWED,
  TAG_FOLLOW_SUGGESTION_DISPOSITIONED,
} from 'constants/events';
import { FollowStreamType } from 'constants/follows';
import { MemberPropertyEnum } from 'constants/memberProperties';
import ToggleFollowingTag from 'creators/follows/ToggleFollowingTag.graphql';
import { selectCurrentUser } from 'selectors/user';
import { track } from 'utilities/analytics';

import { useUpdateMemberProperty } from 'hooks/memberProperties';

import {
  AddSuggestedFollow,
  RemoveSuggestedFollow,
} from './ToggleSuggestedFollow';

import styles from './styles.module.less';

const SuggestedTagFollow = ({ tag, TagLink, declinedStreams }) => {
  const user = useSelector(selectCurrentUser);

  const [followTag] = useMutation(ToggleFollowingTag, {
    refetchQueries: ['GetUserFollowsTag', 'GetUserFollowedStreams'],
    awaitRefetchQueries: true,
  });

  const { updateMemberProperty } = useUpdateMemberProperty(
    MemberPropertyEnum.DECLINED_SUGGESTED_FOLLOW_STREAMS,
    { refetchQueries: ['GetSuggestedStreams'] }
  );

  const addTag = () => {
    followTag({ variables: { follow: true, tag: tag.name } });

    track(TAG_FOLLOW_SUGGESTION_DISPOSITIONED, {
      user_id: user.id,
      tag_id: tag,
      tag_name: tag,
      surface: 'sidebar',
      is_accepted: true,
    });

    track(TAG_FOLLOWED, {
      user_id: user.id,
      tag_id: tag,
      tag_name: tag,
      context_page_path: window.location.pathname,
    });
  };

  const removeTag = () => {
    updateMemberProperty([
      ...declinedStreams,
      { type: FollowStreamType.WORKSPACE_TAG, value: tag.name },
    ]);

    track(TAG_FOLLOW_SUGGESTION_DISPOSITIONED, {
      user_id: user.id,
      tag_id: tag,
      tag_name: tag,
      surface: 'sidebar',
      is_accepted: false,
    });
  };

  return (
    <TagLink
      key={tag.name}
      tag={tag}
      className={styles.suggestedStream}
      actionElement={
        <Arrange gap="xxsmall">
          <AddSuggestedFollow onClick={addTag} />
          <RemoveSuggestedFollow onClick={removeTag} />
        </Arrange>
      }
    />
  );
};

export default SuggestedTagFollow;
